import { setLocale, getLocale } from "@app/paraglide/runtime.js";

// Initialize locale from localStorage or default to "en"
const savedLocale = localStorage.getItem("cc-locale") || "en";

// Create reactive state for locale
export const localeState = $state({ current: savedLocale });

/**
 * Set the application locale. Updates Paraglide runtime,
 * reactive state, and persists to localStorage.
 * @param {string} lang - The locale to set (e.g. "en", "fr")
 */
export function setAppLocale(lang) {
    setLocale(lang, { reload: false });
    localeState.current = lang;
    localStorage.setItem("cc-locale", lang);
}
